/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 418409851acf
 */

import * as z from "zod";
import { streamingProfilesGetStreamingProfile } from "../../funcs/streamingProfilesGetStreamingProfile.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  name: z.string().describe("The name of the streaming profile."),
};

export const tool$streamingProfilesGetStreamingProfile: ToolDefinition<
  typeof args
> = {
  name: "get-streaming-profile",
  description:
    `Retrieves the details of a single adaptive streaming profile by its name`,
  scopes: ["builder"],
  annotations: {
    "title": "Get Streaming Profile",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await streamingProfilesGetStreamingProfile(
      client,
      args.name,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
